module.exports = __webpack_public_path__ + "wave.b621ad52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/events/wave.png
// module id = 2640
// module chunks = 0